import { render, staticRenderFns } from "./EditorFooter.vue?vue&type=template&id=83be96ce"
import script from "./EditorFooter.vue?vue&type=script&lang=js"
export * from "./EditorFooter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports